import React from 'react';
import './style.less';

interface TbLayoutProps {
  children: React.ReactNode
}

const clsPrefix = 'c-tb-layout';
const TbLayout:React.FC<TbLayoutProps> = ({
  children
}) => {
  return (
    <div className={clsPrefix}>
      {children}
    </div>
  )
}

export default TbLayout;